// extracted by mini-css-extract-plugin
export default {"page":"nDeaqQ2izqIoby6iHHBR","error":"Vso_tBsUzjGEJQbRzrVt"};